import {MenuItemType} from '@models/sidebar/menu-item-type';

export class MenuFavoriteItem {
  id: string = '';
  parent: any;
  menuItemName: string = '';
  pageId: string = '';
  itemParentId: string = '';
  itemParentName: string = '';
  nodeItemParentId: string = '';
  itemParentMachine: boolean = false;
  type: MenuItemType = MenuItemType.NONE;
  menuItemId: string = '';
  timestamp: number = 0;
  url: string | undefined = undefined;
  machineCategory?: string | null = null;
  firebaseParentId: string = '';

  get isUserMenuItem(): boolean {
    return this.type === MenuItemType.NODE || this.type === MenuItemType.USER_DEFINED_PAGE;
  }
}
